// Neuen Benutzer mit E-Mail + Passwort anlegen (nur Admin)
import React, { useState } from "react";
import axios from "axios";
import { UserPlus } from "lucide-react";

const ROLES = { reception_com: "Rezeption", manager: "Manager", admin: "Admin" };
const genPw = () => {
  const a = "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789";
  return Array.from(crypto.getRandomValues(new Uint32Array(14)), (n) => a[n % a.length]).join("");
};

export function UserCreateForm({ api, onCreated }) {
  const [f, setF] = useState({ name: "", email: "", role: "reception_com", password: "" });
  const [msg, setMsg] = useState(null);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    const pw = f.password || genPw();
    try {
      await axios.post(api, { ...f, password: pw });
      setMsg({ ok: true, text: `${f.email} angelegt. Start-Passwort (nur jetzt sichtbar): ${pw}` });
      setF({ name: "", email: "", role: "reception_com", password: "" });
      onCreated();
    } catch (er) {
      setMsg({ ok: false, text: er.response?.data?.detail || "Anlegen fehlgeschlagen" });
    }
  };
  return (
    <form onSubmit={submit} className="mt-4 pt-3 border-t border-white/5 space-y-2" data-testid="user-create-form">
      <div className="text-xs font-semibold flex items-center gap-1.5"><UserPlus size={13} /> Benutzer mit E-Mail &amp; Passwort anlegen</div>
      <div className="grid grid-cols-1 sm:grid-cols-4 gap-2">
        <input placeholder="Name" value={f.name} onChange={set("name")} data-testid="user-create-name" />
        <input type="email" required placeholder="E-Mail" value={f.email} onChange={set("email")} data-testid="user-create-email" />
        <select value={f.role} onChange={set("role")} data-testid="user-create-role">
          {Object.entries(ROLES).map(([k, l]) => <option key={k} value={k}>{l}</option>)}
        </select>
        <input type="text" minLength={10} placeholder="Passwort (leer = automatisch)" value={f.password} onChange={set("password")} data-testid="user-create-password" />
      </div>
      <button className="btn !py-1 !px-3 text-xs" data-testid="user-create-submit">Anlegen</button>
      {msg && <div className={`text-xs ${msg.ok ? "text-emerald-300" : "text-rose-400"} select-all`} data-testid="user-create-result">{msg.text}</div>}
    </form>
  );
}
